import React from 'react';

export const withInjectedProps = <P extends object>(
  Component: React.ComponentType<P>,
  injectedProps: Partial<P>,
): React.FC<Omit<P, keyof typeof injectedProps>> => {
  return (props) => <Component {...(injectedProps as P)} {...props as P} />;
};
